export default __webpack_public_path__ + "static/media/135.be18ad78.png";